import { varsFromServer } from './client_side_injection_vars';

export const DEFAULT_CONTROL_VALUE = '1';
export const DEFAULT_VARIANT_VALUE = '2';
export const DEFAULT_ELIGIBLE_EXPERIMENT_VALUES = [DEFAULT_CONTROL_VALUE, DEFAULT_VARIANT_VALUE];

function getActiveExperiments(experimentsString = varsFromServer.experimentsString) {
  if (!experimentsString) return {};

  const experimentsArray = experimentsString.split(';');
  return experimentsArray.reduce((acc, eachExperimentAssignment) => {
    const [experimentKey, experimentValue] = eachExperimentAssignment.split('=');
    acc[experimentKey.trim()] = experimentValue;
    return acc;
  }, {});
}

export function getExperimentValue(key, experimentsString) {
  return getActiveExperiments(experimentsString)[key];
}

export function isExperimentActive(key, experimentsString) {
  return Boolean(getActiveExperiments(experimentsString)[key]);
}

export function shouldShowExperimentVariant(
  experimentString = '',
  experimentName,
  variantValue = DEFAULT_VARIANT_VALUE
) {
  if (!experimentName) {
    return false;
  }
  const expectedExperimentVariant = `${experimentName}=${variantValue}`;

  const experimentsFromQuery = window.location.search || '';
  const hasQueryOverride = experimentsFromQuery.includes(experimentName);
  if (hasQueryOverride) {
    return experimentsFromQuery.includes(expectedExperimentVariant);
  }

  return experimentString.includes(expectedExperimentVariant);
}
